
export const Novel = () => {
 return (
  <>
   Novel
  </>
 )
}